import {
  ADS_PROVIDER_GAM,
  ADS_PROVIDER_PLAYWIRE,
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_ADSENSE,
  setAdsProvider,
} from "./redux/siteData";
import { hasRussianTimezone } from "./util/timezone";
import { getAdConfig, type AdProvider } from "./config/ads";

let adsLoaded = false;

/**
 * Get user's IP address for kill switch override
 * This is a simple client-side approach - you may want to fetch from an API
 */
// async function getUserIP(): Promise<string | null> {
//   try {
//     // Option 1: Use a service to get IP (uncomment if needed)
//     // const response = await fetch("https://api.ipify.org?format=json");
//     // const data = await response.json();
//     // return data.ip;

//     // Option 2: For now, return null (IP checking can be done server-side)
//     return null;
//   } catch (e) {
//     return null;
//   }
// }

export async function loadAds(isRussia: boolean = undefined) {
  if (adsLoaded) {
    return;
  }

  // Get kill switch configuration
  const adConfig = getAdConfig();
  console.log("adConfig", adConfig);

  // Check IP override first
  // const userIP = await getUserIP();
  let finalProvider: AdProvider = adConfig.provider;

  // if (userIP && adConfig.forceProviderForIPs?.includes(userIP)) {
  //   // If IP is in force list, you can override the provider here
  //   // For now, we'll respect the rollout logic
  // }

  // Determine final provider based on config and location
  if (isRussia === undefined) {
    isRussia = await hasRussianTimezone();
  }

  // Yandex for Russia (unless explicitly overridden)
  if (isRussia) {
    finalProvider = ADS_PROVIDER_YANDEX;
  }

  if (finalProvider === ADS_PROVIDER_GAM) {
    loadGam();
  } else if (finalProvider === ADS_PROVIDER_YANDEX) {
    loadYandex();
  } else if (finalProvider === ADS_PROVIDER_ADSENSE) {
    loadAdsense();
  } else {
    loadPlayWire();
  }
  adsLoaded = true;
}

function loadScript(src: string, onload: () => void) {
  const head = document.getElementsByTagName("head")[0];
  const aScript = document.createElement("script");
  aScript.type = "text/javascript";
  aScript.async = true;
  aScript.defer = true;
  aScript.src = src;
  aScript.onload = onload;
  head.appendChild(aScript);
}

// const PREBID_AD_UNIT = {
//   code: "gam-slot-id",
//   mediaTypes: {
//     banner: {
//       sizes: [[300, 600]],
//     },
//   },
//   bids: [], // ✅ EMPTY ON PURPOSE
// };

// function runPrebid() {
//   if (!window.pbjs) {
//     console.warn("pbjs missing");
//     return;
//   }

//   console.log("Prebid loaded");

//   window.pbjs.que.push(() => {
//     console.log("Prebid queue running");

//     window.pbjs.addAdUnits([PREBID_AD_UNIT]);

//     window.pbjs.setConfig({
//       bidderTimeout: 800,
//       debug: true, // ✅ IMPORTANT
//     });

//     window.pbjs.requestBids({
//       bidsBackHandler: () => {
//         console.log("Prebid bidsBackHandler fired");

//         if (!window.googletag || !window.googletag.cmd) {
//           console.warn("GAM not ready yet, delaying refresh");
//           return;
//         }

//         window.googletag.cmd.push(() => {
//           console.log("Setting Prebid targeting + refreshing GAM");
//           window.pbjs.setTargetingForGPTAsync();
//           window.googletag.pubads().refresh();
//         });
//       },
//     });
//   });
// }

// function initGam() {
//   loadScript(
//     "https://fundingchoicesmessages.google.com/i/pub-874852415?ers=3",
//     () => {
//       console.log("Funding choices messages loaded");
//     }
//   );
// }

function loadGam() {
  window.googletag = window.googletag || { cmd: [] };
  // window.pbjs = window.pbjs || {};
  // window.pbjs.que = window.pbjs.que || [];

  loadScript("https://securepubads.g.doubleclick.net/tag/js/gpt.js", () => {
    window.googletag.cmd.push(() => {
      window.googletag.pubads().addEventListener("slotRenderEnded", (event) => {
        console.log("[GAM render]", {
          adUnit: event.slot.getAdUnitPath(),
          isEmpty: event.isEmpty,
          size: event.size,
          advertiserId: event.advertiserId,
          campaignId: event.campaignId,
          lineItemId: event.lineItemId,
          creativeId: event.creativeId,
        });
      });

      // window.googletag.pubads().disableInitialLoad(); // 🔴 REQUIRED
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
    });

    setAdsProvider(ADS_PROVIDER_GAM);
    // });
    // loadScript("/prebid10.20.0.js", () => {
    //   runPrebid();
    // });
  });
}

function loadPlayWire() {
  const head = document.getElementsByTagName("head")[0];

  const aScript = document.createElement("script");
  aScript.type = "text/javascript";
  aScript.async = true;
  aScript.defer = true;
  aScript.src = "//cdn.intergient.com/1024554/73358/ramp.js";
  head.appendChild(aScript);

  window.ramp.onReady = () => {
    setAdsProvider(ADS_PROVIDER_PLAYWIRE);
  };
}

function loadAdsense() {
  // if (process.env.NODE_ENV === "development") {
  //   return;
  // }

  console.log("loadAdsense");
  const head = document.getElementsByTagName("head")[0];

  const aScript = document.createElement("script");
  aScript.type = "text/javascript";
  aScript.async = true;
  aScript.src =
    "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3075327144693930";
  head.appendChild(aScript);

  aScript.onload = () => {
    setAdsProvider(ADS_PROVIDER_ADSENSE);
  };
}

function loadYandex() {
  window.yaContextCb = window.yaContextCb || [];
  const head = document.getElementsByTagName("head")[0];

  const aScript = document.createElement("script");
  aScript.type = "text/javascript";
  aScript.async = true;
  aScript.src = "https://yandex.ru/ads/system/context.js";
  head.appendChild(aScript);

  aScript.onload = () => {
    setAdsProvider(ADS_PROVIDER_YANDEX);
  };
}
